// DO NOT EDIT -- generated from fs/services/dx-objects/pages.proto

import * as pages from '../../api/pages';
import * as paige from '../paige';
import * as protobuf from '../../../google/protobuf';

export namespace PagesPublic {

  export const ArchivePageEndpoint = "/grpc/dx_objects.PagesPublic/ArchivePage";
  /** Archives/unarchives a page definition */
  export function ArchivePage(sender: (req: ArchivePageRequest, endpoint: string) => Promise<ArchivePageResponse>, req: ArchivePageRequest): { promise: () => Promise<ArchivePageResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ArchivePageEndpoint),
      endpoint: ArchivePageEndpoint
    };
  }

  export const ArchivePagesEndpoint = "/grpc/dx_objects.PagesPublic/ArchivePages";
  /** Archives multiple page definitions */
  export function ArchivePages(sender: (req: paige.ArchiveMultiRequest, endpoint: string) => Promise<paige.ArchiveMultiReply>, req: paige.ArchiveMultiRequest): { promise: () => Promise<paige.ArchiveMultiReply>, endpoint: string } {
    return {
      promise: () => sender(req, ArchivePagesEndpoint),
      endpoint: ArchivePagesEndpoint
    };
  }

  export const GetAllPagesEndpoint = "/grpc/dx_objects.PagesPublic/GetAllPages";
  /** Gets all pages */
  export function GetAllPages(sender: (req: GetAllPagesRequest, endpoint: string) => Promise<GetAllPagesResponse>, req: GetAllPagesRequest): { promise: () => Promise<GetAllPagesResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAllPagesEndpoint),
      endpoint: GetAllPagesEndpoint
    };
  }

  export const GetPageEndpoint = "/grpc/dx_objects.PagesPublic/GetPage";
  /** Gets a specific page */
  export function GetPage(sender: (req: GetPageRequest, endpoint: string) => Promise<GetPageResponse>, req: GetPageRequest): { promise: () => Promise<GetPageResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetPageEndpoint),
      endpoint: GetPageEndpoint
    };
  }

  export const SetPageEndpoint = "/grpc/dx_objects.PagesPublic/SetPage";
  /** Sets a page */
  export function SetPage(sender: (req: SetPageRequest, endpoint: string) => Promise<SetPageResponse>, req: SetPageRequest): { promise: () => Promise<SetPageResponse>, endpoint: string } {
    return {
      promise: () => sender(req, SetPageEndpoint),
      endpoint: SetPageEndpoint
    };
  }

  export const SearchEndpoint = "/grpc/dx_objects.PagesPublic/Search";
  export function Search(sender: (req: paige.SearchRequest, endpoint: string) => Promise<paige.SearchReply>, req: paige.SearchRequest): { promise: () => Promise<paige.SearchReply>, endpoint: string } {
    return {
      promise: () => sender(req, SearchEndpoint),
      endpoint: SearchEndpoint
    };
  }

  export const AutocompleteEndpoint = "/grpc/dx_objects.PagesPublic/Autocomplete";
  export function Autocomplete(sender: (req: paige.AutocompleteRequest, endpoint: string) => Promise<paige.AutocompleteReply>, req: paige.AutocompleteRequest): { promise: () => Promise<paige.AutocompleteReply>, endpoint: string } {
    return {
      promise: () => sender(req, AutocompleteEndpoint),
      endpoint: AutocompleteEndpoint
    };
  }

  export const MatchEndpoint = "/grpc/dx_objects.PagesPublic/Match";
  export function Match(sender: (req: MatchRequest, endpoint: string) => Promise<MatchReply>, req: MatchRequest): { promise: () => Promise<MatchReply>, endpoint: string } {
    return {
      promise: () => sender(req, MatchEndpoint),
      endpoint: MatchEndpoint
    };
  }

  export const SetMLStateEndpoint = "/grpc/dx_objects.PagesPublic/SetMLState";
  export function SetMLState(sender: (req: paige.SetMLStateRequest, endpoint: string) => Promise<{}>, req: paige.SetMLStateRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, SetMLStateEndpoint),
      endpoint: SetMLStateEndpoint
    };
  }

  export const SilenceIssueEndpoint = "/grpc/dx_objects.PagesPublic/SilenceIssue";
  export function SilenceIssue(sender: (req: PageIssueSilenceRequest, endpoint: string) => Promise<PageIssueSilenceResponse>, req: PageIssueSilenceRequest): { promise: () => Promise<PageIssueSilenceResponse>, endpoint: string } {
    return {
      promise: () => sender(req, SilenceIssueEndpoint),
      endpoint: SilenceIssueEndpoint
    };
  }

  export const UnSilenceIssueEndpoint = "/grpc/dx_objects.PagesPublic/UnSilenceIssue";
  export function UnSilenceIssue(sender: (req: PageIssueUnSilenceRequest, endpoint: string) => Promise<PageIssueUnSilenceResponse>, req: PageIssueUnSilenceRequest): { promise: () => Promise<PageIssueUnSilenceResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UnSilenceIssueEndpoint),
      endpoint: UnSilenceIssueEndpoint
    };
  }

  export const GetSuggestedPageEndpoint = "/grpc/dx_objects.PagesPublic/GetSuggestedPage";
  /** Gets a specific page suggestion */
  export function GetSuggestedPage(sender: (req: GetSuggestedPageRequest, endpoint: string) => Promise<GetSuggestedPageResponse>, req: GetSuggestedPageRequest): { promise: () => Promise<GetSuggestedPageResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetSuggestedPageEndpoint),
      endpoint: GetSuggestedPageEndpoint
    };
  }

  export const SetSuggestedPageEndpoint = "/grpc/dx_objects.PagesPublic/SetSuggestedPage";
  export function SetSuggestedPage(sender: (req: SetSuggestedPageRequest, endpoint: string) => Promise<SetSuggestedPageResponse>, req: SetSuggestedPageRequest): { promise: () => Promise<SetSuggestedPageResponse>, endpoint: string } {
    return {
      promise: () => sender(req, SetSuggestedPageEndpoint),
      endpoint: SetSuggestedPageEndpoint
    };
  }

  export const UpdatePageSuggestionsStatusesEndpoint = "/grpc/dx_objects.PagesPublic/UpdatePageSuggestionsStatuses";
  export function UpdatePageSuggestionsStatuses(sender: (req: UpdatePageSuggestionsStatusesRequest, endpoint: string) => Promise<UpdatePageSuggestionsStatusesResponse>, req: UpdatePageSuggestionsStatusesRequest): { promise: () => Promise<UpdatePageSuggestionsStatusesResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UpdatePageSuggestionsStatusesEndpoint),
      endpoint: UpdatePageSuggestionsStatusesEndpoint
    };
  }

  export const SetPagesFromSuggestionsEndpoint = "/grpc/dx_objects.PagesPublic/SetPagesFromSuggestions";
  export function SetPagesFromSuggestions(sender: (req: SetPagesFromSuggestionsRequest, endpoint: string) => Promise<SetPagesFromSuggestionsResponse>, req: SetPagesFromSuggestionsRequest): { promise: () => Promise<SetPagesFromSuggestionsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, SetPagesFromSuggestionsEndpoint),
      endpoint: SetPagesFromSuggestionsEndpoint
    };
  }
}

/**
 * PageDetail is a seat's view of a Page.
 * Currently, it only contains a PageDefinition, but in the future it will contain other UI configuration
 * like categorization or view history.
 */
export interface PageDetail {
  page: pages.PageDefinition | null;
}

export interface ArchivePageRequest {
  orgId: string;
  pageId: number;
  /** True to archive, false to unarchive */
  archived: boolean;
}

export interface ArchivePageResponse {
  /** Only returns errors on unarchive */
  errors: paige.ValidationError[];
  page: PageDetail | null;
}

/** This ONLY archives pages. Batch unarchiving is currently NOT supported because of collision issues. */
export interface ArchivePagesRequest {
  orgId: string;
  ids: number[];
}

export interface ArchivePagesResponse {
  archived: number[];
}

export interface GetAllPagesRequest {
  orgId: string;
  /** Whether to return archived for user defined and learned pages */
  userDefinedPages: paige.GetAllRequest.Filter;
  learnedPages: paige.GetAllRequest.Filter;
  includeSuggested: boolean;
}

export interface GetAllPagesResponse {
  pages: PageDetail[];
  learnedLimit: number;
  maxPages: number;
  mlState: paige.MLState;
  pendingSuggestedPages: PageDetail[];
}

export interface GetPageRequest {
  orgId: string;
  pageId: number;
}

export interface GetPageResponse {
  page: PageDetail | null;
}

export interface SetPageRequest {
  orgId: string;
  page: pages.PageDefinition | null;
}

export interface SetPageResponse {
  page: PageDetail | null;
  errors: paige.ValidationError[];
}

/** MatchRequest mimics Paige's internal MatchRequest but doesn't support destructure behavior */
export interface MatchRequest {
  orgId: string;
  url: string;
}

export interface MatchReply {
  pageDefId: number;
}

export interface PageIssueSilence {
  id: string;
  pageId: number;
  expiresAt: protobuf.timestamp | null;
}

export interface PageIssueSilenceRequest {
  orgId: string;
  pageId: number;
  expiresAt: protobuf.timestamp | null;
}

export interface PageIssueSilenceResponse {
  issueSilence: PageIssueSilence | null;
}

export interface PageIssueUnSilenceRequest {
  orgId: string;
  pageId: number;
  issueSilenceId: string;
}

export interface PageIssueUnSilenceResponse {
  issueSilenceId: string;
  pageId: number;
}

export interface GetSuggestedPageRequest {
  orgId: string;
  suggestionId: string;
}

export interface GetSuggestedPageResponse {
  suggestion: PageDetail | null;
}

export interface SetSuggestedPageRequest {
  orgId: string;
  suggestion: pages.PageSuggestion | null;
}

export interface SetSuggestedPageResponse {
  suggestion: PageDetail | null;
}

export interface UpdatePageSuggestionsStatusesRequest {
  orgId: string;
  suggestionIds: string[];
  status: pages.SuggestionStatus;
}

export interface UpdatePageSuggestionsStatusesResponse {
  suggestionIds: string[];
}

export interface SetPagesFromSuggestionsRequest {
  orgId: string;
  suggestionIds: string[];
}

export interface SetPagesFromSuggestionsResponse {
  pages: PageDetail[];
  errors: paige.ValidationError[];
}
